import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo10 } from "../../../routes/Module10";
import { modulo11 } from "../../../routes/Module11";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import Imagen from "../../../images/modulo10/legislativo.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo10/Actividad 9.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo10.content[0];
  const infoAct = modulo10.content[0].activities[8];
  const crumbs = [
    {
      title: modulo10.title,
      url: "/" + modulo10.url,
    },
    {
      title:
        modulo10.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo10.content[0].activities[7].name}`,
    linkPrev: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[7].path}`,
  };
  const metadata = {
    color: modulo10.color,
    title: `${modulo10.title} - ${infoAct.name}`,
    name: modulo10.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo10.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="mb-5">
        <li>
          Piensa en una ley que podría ser positiva para los niños y niñas de tu
          región y escríbela aquí.
        </li>
      </ul>

      <div className="row">
        <div className="col-lg-8 col-12">
          <textarea className="form-control" rows={4} />
        </div>
        <div className="col-lg-8 col-12">
        <img src={Imagen} className="img-fluid" alt="..." />

        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Dialoguen sobre posibles leyes. Oriente la
          conversación para que se trate de algo beneficioso para la mayoría de
          niños y niñas de la región.
        </p>
      </GuiaDocente>
      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo11.url}>
          <button className={`btn btn-${modulo10.color} me-2`}>
            {modulo11.title + " >"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Actividad9;
